import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import Form from '../../layout/form/Form';
import ContentCadastro from '../../layout/content/ContentCadastro';
import Input from '../../layout/input/Input';
import InputNumber from '../../layout/input/InputNumber';
import InputMoeda from '../../layout/input/InputMoeda';
import Button from '../../layout/button/ButtonCol';
import ModalQuestion from '../../layout/modal/ModalQuestion';
import Preload from '../../layout/preload/Preload';

import InputSelectModalidadePagamento from './InputSelectModalidadePagamento';

import FormasPagamentoService from '../../../service/FormasPagamentoService';

import FormCodeEnum from '../../../helper/enumerador/FormCodeEnum';

import { getParam } from '../../../helper/Url';
import { dataHoraAtual } from '../../../helper/Formatar';

class Cadastro extends AbstractComponent { 
    constructor(props) {
        super(props);

        this.state = {
            salvar: {
                disabled: true,
                name: 'Salvar'
            },

            erro: {
                message: '',
                code: 0
            },

            preload: false,

            preloadModal: false,

            sucesso: false,            

            modalErroMsg: {
                message: '',
                code: 0
            },

            modalExclusaoParcela: false,

            modalExcluirTodasParcelas: false,

            indexExclusaoParcela: -1,

            head: [
                {nome: 'Parcela', campo: 'parcela'}, 
                {nome: 'Desconto', campo: 'desconto'}, 
                {nome: 'Acréscimo', campo: 'acrescimo'},
                {nome: 'Compras a partir de', campo: 'compras_a_partir_de'},
            ],                    

            form: {                
                id: 0,                    
                descricao: '',
                id_modalidade_pagamento: 0,
                qtde_parcelas: 1,
                desconto: 0,
                acrescimo: 0,
                compras_a_partir_de: 0,

                persistencia: {
                    criado_por: '',
                    alterado_por: '',
                    cadastrado_em: '',
                    alterado_em: ''
                },

                formas_pagamento_item: []
            },

            erroForm: {
                descricao: '',
                id_modalidade_pagamento: '', 
                qtde_parcelas: ''                           
            }
        }
        
        const data = dataHoraAtual();
        const persistencia = {
            cadastrado_em: data,
            alterado_em: data,
            criado_por: '',
            alterado_por: ''
        };

        this.state.form.persistencia = persistencia;
    }

    onModalidadePagamentoChange(e) {  
        this.setState({preloadModal: true});

        var form = this.state.form;                         
                
        form.id_modalidade_pagamento = e.target.value;

        var salvar = this.state.salvar;
        
        salvar.disabled = false;        

        this.setState({
            form: form,
            salvar: salvar,
            preloadModal: false
        });        
    }

    onChange(e) {        
        var form = this.state.form;                         
                
        form[e.target.name] = e.target.value;

        var salvar = this.state.salvar;
        
        salvar.disabled = false;        

        this.setState({
            form: form,
            salvar: salvar
        });
    }     

    limparErroForm() {
        var erroForm = this.state.erroForm;
        
        erroForm.id_modalidade_pagamento = '';
        erroForm.qtde_parcelas = '';        
        
        this.setState({
            erroForm: erroForm,
            erro: {
                message: '',
                code: 0
            }
        });
    }

    canSave() {
        this.limparErroForm();

        var form = this.state.form;
        var erroForm = this.state.erroForm;     
        var erroTxt = '';     
        var erro = false;
        
        if(!form.id_modalidade_pagamento) {
            erroForm.id_modalidade_pagamento = 'Informe o campo Modalidade de Pagamento';
            erro = true;
        }

        if(parseInt(form.qtde_parcelas,10) < 1) {
            erroForm.qtde_parcelas = 'O campo Qtde de Parcelas deve ser maior que 0';
            erro = true;
        }             

        if(form.formas_pagamento_item.length === 0) {
            erroTxt = 'Você deve fornecer pelo menos 1 parcela';
            erro = true;
        }

        if(erro) {                                           
            this.setState({
                erroForm: erroForm,
                erro: {
                    message: erroTxt,
                    code: FormCodeEnum.DEFAULT
                }
            });

            return false;
        }

        return true;
    }

    onSubmit(e) {        
        if(!this.canSave())            
            return ;        
            
        var salvar = this.state.salvar;

        salvar.disabled = true;
        salvar.name = 'Aguarde...';

        this.setState({ 
            salvar: salvar,
            erro: {
                message: '',
                code: 0
            }
        });                             

        let form = this.state.form;
        let persistencia = form.persistencia;

        persistencia.criado_por = this.props.usuario.nome;
        persistencia.alterado_por = this.props.usuario.nome;        

        form.persistencia = persistencia;        

        FormasPagamentoService.gravar(
            form
        ).then((resposta) => {
            var salvar = this.state.salvar;
        
            salvar.name = 'Salvar';

            var form = this.state.form;            

            form = resposta.data;            

            this.setState({
                form: form,
                salvar: salvar,
                sucesso: true
            });
        }).catch((erro) => {
            var salvar = this.state.salvar;

            salvar.disabled = false;
            salvar.name = 'Salvar';

            this.setState({
                erro: this.trataErro(erro),
                salvar: salvar
            });
        });
    }    

    onDescontoChange(e, index) {
        let form = this.state.form;
        const formasPagamento = form.formas_pagamento_item;        
        const data = dataHoraAtual();
        const fPagto = formasPagamento[index];

        const persistencia = {
            cadastrado_em: fPagto.persistencia.cadastrado_em,
            alterado_em: data,
            criado_por: fPagto.persistencia.criado_por,
            alterado_por: this.props.usuario.nome
        };

        formasPagamento.splice(index, 1, {
            id_formas_pagamento_cab: form.id,
            parcela: fPagto.parcela,
            desconto: e.target.value,
            acrescimo: fPagto.acrescimo,
            compras_a_partir_de: fPagto.compras_a_partir_de,
            persistencia: persistencia
        });

        form.formas_pagamento_item = formasPagamento;

        this.setState({form: form});
    }

    onAcrescimoChange(e, index) {
        let form = this.state.form;
        const formasPagamento = form.formas_pagamento_item;        
        const data = dataHoraAtual();
        const fPagto = formasPagamento[index];

        const persistencia = {
            cadastrado_em: fPagto.persistencia.cadastrado_em,
            alterado_em: data,
            criado_por: fPagto.persistencia.criado_por,
            alterado_por: this.props.usuario.nome
        };

        formasPagamento.splice(index, 1, {
            id_formas_pagamento_cab: form.id,
            parcela: fPagto.parcela,
            desconto: fPagto.desconto,
            acrescimo: e.target.value,
            compras_a_partir_de: fPagto.compras_a_partir_de,
            persistencia: persistencia
        });

        form.formas_pagamento_item = formasPagamento;

        this.setState({form: form});
    }    

    removeParcela() {
        let form = this.state.form;
        let fPagto = form.formas_pagamento_item;

        fPagto.splice(this.state.indexExclusaoParcela, 1);

        form.formas_pagamento_item = fPagto;
        form.qtde_parcelas--;

        this.setState({
            form: form,
            indexExclusaoParcela: -1,
            modalExclusaoParcela: false
        });
    }

    excluirParcela(index) {
        if((index+1) < this.state.form.qtde_parcelas) {
            this.setState({
                modalErroMsg: {
                    message: 'Você só pode excluir a última parcela',
                    code: FormCodeEnum.DEFAULT
                }
            });

            return ;
        }

        this.setState({modalExclusaoParcela: true, indexExclusaoParcela: index})
    }

    showFormaPagamento() {
        return (
            this.state.form.formas_pagamento_item.map((item, index) => {
                return (
                    <div key={index} className="row"> 
                        <InputNumber
                            md={3} 
                            xs={12}
                            sm={3} 
                            lg={3}
                            style={{border: '1px solid #e6e4e6'}}
                            id={"parcela_" + index}
                            nome={"parcela_" + index}                            
                            value={item.parcela}                                                                                 
                            disabled={true}
                        >                    
                            Parcela
                        </InputNumber>  

                        <InputMoeda
                            md={3} 
                            xs={4}
                            sm={3} 
                            lg={3}    
                            style={{border: '1px solid #e6e4e6'}}                        
                            id={"desconto_" + index}
                            name={"desconto_" + index}                                                      
                            value={item.desconto}
                            defaultValue={item.desconto}
                            defaultFoco={true}
                            onChangeEvent={(e) => this.onDescontoChange(e, index)}
                        >
                            Desconto (%)
                        </InputMoeda>     

                        <InputMoeda
                            md={3} 
                            xs={4}
                            sm={3} 
                            lg={3}    
                            style={{border: '1px solid #e6e4e6'}}
                            id={"acrescimo_" + index}
                            name={"acrescimo_" + index}                                                       
                            value={item.acrescimo}
                            defaultValue={item.acrescimo}
                            defaultFoco={true}
                            onChangeEvent={(e) => this.onAcrescimoChange(e, index)}
                        >
                            Acréscimo (%)
                        </InputMoeda>                                                                     
                        
                        <Button
                            md={3} 
                            xs={4}
                            sm={3} 
                            lg={3} 
                            className="btn btn-danger"
                            style={{border: '1px solid #e6e4e6'}}
                            width={'45px'}
                            background={1}
                            type="button"
                            onClick={() => this.excluirParcela(index)}
                        >
                            <i className="fas fa-times" />
                        </Button>                        
                    </div>
                )
            })
        )
    }

    excluirTodasParcelas() {
        let form = this.state.form;        

        form.formas_pagamento_item = [];

        this.setState({
            form: form,
            modalExcluirTodasParcelas: false
        });
    }

    gerarParcela() {
        FormasPagamentoService.formaPagamentoNotExists(
            this.state.form.id,
            this.state.form.id_modalidade_pagamento,
            this.state.form.qtde_parcelas,
            this.state.form.compras_a_partir_de
        ).then(() => {        
            let form = this.state.form;
            let formas_pagamento_item = form.formas_pagamento_item;
            const data = dataHoraAtual();
            const persistencia = {
                cadastrado_em: data,
                alterado_em: data,
                criado_por: this.props.usuario.nome,
                alterado_por: this.props.usuario.nome
            };

            for(var cont = 1; cont <= form.qtde_parcelas; cont++) {
                formas_pagamento_item.push({
                    id_formas_pagamento_cab: form.id,
                    parcela: cont,
                    desconto: this.state.form.desconto,
                    acrescimo: this.state.form.acrescimo,
                    compras_a_partir_de: this.state.form.compras_a_partir_de,
                    persistencia: persistencia
                });
            }   
            
            form.formas_pagamento_item = formas_pagamento_item;

            this.setState({form: form});
        }).catch(erro => {
            this.setState({
                modalErroMsg: this.trataErro(erro),
                preloadModal: false
            })
        });        
    }

    componentDidMount() {
        const id = getParam('id');        

        if((id === undefined)||(id === null)||(id === 0))
            return ;            

        this.setState({
            modalErroMsg: {
                message: '',
                code: 0
            },
            preload: true
        });

        FormasPagamentoService.buscar(id).then(resposta => {
            this.setState({
                form: resposta.data,
                modalErroMsg: {
                    message: '',
                    code: 0
                },
                preload: false
            });
        }).catch(erro => {
            this.setState({
                modalErroMsg: this.trataErro(erro),
                preload: false
            });
        });        
    }

    render() {
        return(                                                                             
            <div>
                <ModalQuestion
                    show={this.state.modalExclusaoParcela}
                    header="Pergunta"
                    texto={"Tem certeza de que deseja excluir a parcela [" + (this.state.indexExclusaoParcela + 1) + "]?"}
                    buttonSimTxt="Sim"
                    buttonNaoTxt="Não"

                    fechar={() => this.setState({modalExclusaoParcela: false, indexExclusaoParcela: -1})}
                    btnSimClick={() => this.removeParcela()}
                    btnNaoClick={() => this.setState({modalExclusaoParcela: false, indexExclusaoParcela: -1})}
                />  

                <ModalQuestion
                    show={this.state.modalExcluirTodasParcelas}
                    header="Pergunta"
                    texto="Tem certeza de que deseja excluir TODAS as parcelas?"
                    buttonSimTxt="Sim"
                    buttonNaoTxt="Não"

                    fechar={() => this.setState({modalExcluirTodasParcelas: false})}
                    btnSimClick={() => this.excluirTodasParcelas()}
                    btnNaoClick={() => this.setState({modalExcluirTodasParcelas: false})}
                />                                

                <Preload show={this.state.preloadModal} />

                <Form onSubmit={(e) => this.onSubmit(e)} id="form">
                    <ContentCadastro 
                        title="Formas de Pagamento"
                        history={'configuracao/formas-pagamento'}
                        
                        preload={this.state.preload || this.props.preload}
                        sucesso={this.state.sucesso}
                        textoSucesso="Forma de Pagamento salvo com sucesso"
                        modalErroMsg={this.state.modalErroMsg}

                        salvar={this.state.salvar}    
                        erro={this.state.erro}                

                        onSalvar="submit"                    
                        onSucesso={() => this.setState({sucesso: false})}
                        fecharModal={() => this.setState({modalErroMsg: this.finalizaErro(this.state.modalErroMsg)})}

                        route={(route) => this.props.route(route)}
                    >        
                        <div className="row">
                            <Input
                                md={12} 
                                xs={12}
                                sm={12} 
                                lg={12}
                                id="descricao"
                                nome="descricao"                                
                                value={this.state.form.descricao}                         
                                erro={this.state.erroForm.descricao}
                                onChange={(e) => this.onChange(e)}                    
                            >                    
                                Descrição
                            </Input>

                            <InputSelectModalidadePagamento
                                md={12} 
                                xs={12} 
                                sm={12} 
                                lg={12}
                                id="id_modalidade_pagamento"
                                nome="id_modalidade_pagamento"
                                maxLength={17}
                                disabled={this.state.form.formas_pagamento_item.length > 0}
                                value={this.state.form.id_modalidade_pagamento}
                                defaultValue={this.state.form.id_modalidade_pagamento}                            
                                erro={this.state.erroForm.id_modalidade_pagamento}                    
                                onChange={(e) => this.onModalidadePagamentoChange(e)}
                            />
                            
                            <InputNumber
                                md={2} 
                                xs={12}
                                sm={2} 
                                lg={2}
                                id="qtde_parcelas"
                                nome="qtde_parcelas"
                                disabled={this.state.form.formas_pagamento_item.length > 0}
                                value={this.state.form.qtde_parcelas}                         
                                erro={this.state.erroForm.qtde_parcelas}                                
                                onChange={(e) => this.onChange(e)}                    
                            >                    
                                Qtde de Parcelas
                            </InputNumber>  

                            <InputMoeda
                                md={2} 
                                xs={12}
                                sm={2} 
                                lg={2}                            
                                id="desconto"
                                name="desconto"         
                                disabled={this.state.form.formas_pagamento_item.length > 0}
                                value={this.state.form.desconto}
                                defaultValue={this.state.form.desconto}
                                defaultFoco={true}
                                onChangeEvent={(e) => this.onChange(e)}
                            >
                                Desconto (%)
                            </InputMoeda>     

                            <InputMoeda
                                md={2} 
                                xs={12}
                                sm={2} 
                                lg={2}                            
                                id="acrescimo"
                                name="acrescimo"                                                      
                                value={this.state.form.acrescimo}
                                defaultValue={this.state.form.acrescimo}
                                defaultFoco={true}
                                disabled={this.state.form.formas_pagamento_item.length > 0}
                                onChangeEvent={(e) => this.onChange(e)}
                            >
                                Acréscimo (%)
                            </InputMoeda> 

                            <InputMoeda
                                md={3} 
                                xs={12}
                                sm={3} 
                                lg={3}                            
                                id="compras_a_partir_de"
                                name="compras_a_partir_de"                                                      
                                value={this.state.form.compras_a_partir_de}
                                defaultValue={this.state.form.compras_a_partir_de}
                                defaultFoco={true}                                
                                onChangeEvent={(e) => this.onChange(e)}
                            >
                                Compras a partir de (R$)
                            </InputMoeda>
                            
                            {
                                this.state.form.formas_pagamento_item.length === 0 &&
                                <Button
                                    md={3} 
                                    xs={12}
                                    sm={3} 
                                    lg={3} 
                                    type="button"
                                    onClick={() => this.gerarParcela()}                            
                                >
                                    Gerar Parcelas
                                </Button>                            
                            }                            

                            {
                                this.state.form.formas_pagamento_item.length > 0 &&
                                <Button
                                    md={3} 
                                    xs={12}
                                    sm={3} 
                                    lg={3} 
                                    className="btn btn-danger"
                                    type="button"
                                    onClick={() => this.setState({modalExcluirTodasParcelas: true})}                            
                                >
                                    Excluir todas as parcelas
                                </Button>                            
                            }
                        </div>

                        {this.showFormaPagamento()}
                    </ContentCadastro>            
                </Form>
            </div>
        )
    }
}

export default Cadastro;